<div *ngIf="componentReady" [formGroup]="inputForm">
  <app-text-field formControlName="email"></app-text-field>
</div>
